module.exports = __webpack_public_path__ + "img/checklist_prew_1.e3865bcd.png";